import { RootReducerStateT } from 'app/reducers/rootReducer';
import {
  defaultFeatureFlags,
  FeatureFlagName,
  featureFlags,
  FeatureFlags,
} from 'utils/featureFlagging/featureFlags';

/**
 * Returns the state of a given feature flag.
 *
 * @deprecated Use `useFeatureFlag` instead.
 * @param state The app state.
 * @param name The name of the feature flag to check against.
 */
export function hasFeature<TFeatureFlagName extends FeatureFlagName>(
  rootStateOrFlags: RootReducerStateT | FeatureFlags,
  name: TFeatureFlagName,
): FeatureFlags[TFeatureFlagName] {
  // Leave rootState for backwards compatibility and allow to provide feature flags directly
  const stateFeatureFlags =
    rootStateOrFlags?.['settings']?.profile?.featureflags;

  const flags = stateFeatureFlags ?? rootStateOrFlags;

  const defaultValue = defaultFeatureFlags[name];

  if (flags && name in flags) {
    featureFlags.track([name]);
    return flags[name] ?? defaultValue;
  }

  // Handles the case where LaunchDarkly works as expected,
  // but a flag referenced in code doesn't exist in LaunchDarkly.
  return defaultValue;
}
